import { useMutation, useQueryClient } from "react-query";

import ResponsiveDialog from "../../components/ResponsiveDialog";
import { getModelLabel } from "./constants";
import { setActiveModel } from "./services";

const ActivateModelDialog = ({
  modelName,
  onClose,
}: {
  modelName: string | null;
  onClose: () => void;
}) => {
  const queryClient = useQueryClient();

  const setActiveModelMutation = useMutation(
    (name: string) => setActiveModel(name),
    { onSuccess: () => queryClient.invalidateQueries("ml-analysis-metrics") }
  );

  return (
    <ResponsiveDialog
      fullWidth
      open={modelName !== null}
      onClose={onClose}
      title={`Activer le modèle « ${
        modelName ? getModelLabel(modelName) : ""
      } » en production ?`}
      contentText="Attention, ce modèle remplacera le modèle actuellement utilisé en production pour générer les prévisions d'annulation."
      loading={setActiveModelMutation.isLoading}
      onSubmit={() => {
        if (modelName) {
          setActiveModelMutation.mutate(modelName, { onSettled: onClose });
        }
      }}
    />
  );
};

export default ActivateModelDialog;
